import { useIsMutating } from "@tanstack/react-query";

// use this to tell if an experiment specific mutation is in progress
export const useIsExperienceMutating = (
  mutationKey: string,
  experienceId: string
) => {
  return useIsMutating({
    mutationKey: [mutationKey],
    predicate: (mutation) =>
      (mutation.state.variables as { pathParams: { experienceId: string } })
        ?.pathParams?.experienceId === experienceId,
  });
};
